// import {createSlice} from "@reduxjs/toolkit";

// const initialState={
//     imageData:[],
//     optixData:[],
//     sdkData:[],
//     mobileData:[],
//     resultData:[],
//     questionListData:[],
//     isLoading:false,
//     error:false,
//     activeProject: null,
// }

// const skidSlice = createSlice({
//     name: "imageViewer",
//     initialState,
//     reducers: {
//       getDataStart: (state) => {
//         state.isLoading = true;
//       },
//       getDataSuccess:(state,action)=>{
//         state.imageData=action.payload;
//       },
//       getOptixDataSuccess:(state,action)=>{
//         state.optixData=action.payload
//       },
//       getSdkDataSuccess:(state,action)=>{
//         state.sdkData=action.payload
//       },
//       getMobileDataSuccess:(state,action)=>{
//         state.mobileData=action.payload
//       },
//       getResultDataSuccess:(state,action)=>{
//         state.resultData=action.payload
//       },
//       getQuestionListDataSuccess:(state,action)=>{
//         state.questionListData=action.payload
//       },
//       getDataFailure: (state) => {
//         state.isLoading = false;
//         state.error = true;
//       },
//       getDataEnd:(state)=>{
//         state.isLoading = false;
//       },
//       resetSkidSlice:(state) => {
//         return initialState;
//       },
//       setActiveProject: (state, action) => {
//         state.activeProject = action.payload;
//       },
//       clearOptixData:(state)=>{
//         state.optixData=[];
//       },
//       clearOptixImageSdkMobileData:(state)=>{
//         state.imageData=[];
//         state.mobileData=[];
//         state.optixData=[];
//         state.sdkData=[];
//       },
//       clearImageData:(state)=>{
//         state.imageData=[];

//       }
//     }
//   });

// export const {getDataStart, getDataSuccess, getDataFailure,getDataEnd,getOptixDataSuccess,getSdkDataSuccess,getMobileDataSuccess, getResultDataSuccess,getQuestionListDataSuccess,resetSkidSlice,setActiveProject,clearOptixData,clearOptixImageSdkMobileData,clearImageData }= skidSlice.actions;

// export default skidSlice.reducer;

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  imageData: [],
  optixData: [],
  sdkData: [],
  logData: [],
  mobileData: [],
  resultData: [],
  newExpandedNode: ["root"],
  status: null,
  expandedNodeLive: [],
  newExpandedNodeLive: [],
  expandedNode: ["root"],
  treeDataRedux: [],
  questionListData: [],
  isLoading: false,
  error: false,
  dataType: "Archived",
  activeProject: null,
};

const skidSlice = createSlice({
  name: "imageViewer",
  initialState,
  reducers: {
    getDataStart: (state) => {
      state.isLoading = true;
    },
    getDataSuccess: (state, action) => {
      state.imageData = action.payload;
    },
    getLogSuccess: (state, action) => {
      state.logData = action.payload;
    },
    getOptixDataSuccess: (state, action) => {
      state.optixData = action.payload;
    },
    getSdkDataSuccess: (state, action) => {
      state.sdkData = action.payload;
    },
    getMobileDataSuccess: (state, action) => {
      state.mobileData = action.payload;
    },
    getResultDataSuccess: (state, action) => {
      state.resultData = action.payload;
    },
    getQuestionListDataSuccess: (state, action) => {
      state.questionListData = action.payload;
    },
    getDataFailure: (state) => {
      state.isLoading = false;
      state.error = true;
    },
    getDataEnd: (state) => {
      state.isLoading = false;
    },
    resetSkidSlice: (state) => {
      return initialState;
    },
    setActiveProject: (state, action) => {
      state.activeProject = action.payload;
    },
    clearOptixData: (state) => {
      state.optixData = [];
    },
    clearOptixImageSdkMobileData: (state) => {
      state.imageData = [];
      state.mobileData = [];
      state.optixData = [];
      state.sdkData = [];
    },
    clearImageData: (state) => {
      state.imageData = [];
    },
    setTreeNode: (state, action) => {
      state.expandedNode = action.payload;
    },
    expandNode: (state, action) => {
      if (!state.expandedNode.includes(action.payload)) {
        state.expandedNode.push(action.payload);
      }
    },
    collapseNode: (state, action) => {
      state.expandedNode = state.expandedNode.filter(
        (nodeId) => nodeId !== action.payload
      );
    },
    expandNodeNew: (state, action) => {
      if (!state.newExpandedNode.includes(action.payload)) {
        state.newExpandedNode.push(action.payload);
      }
    },
    collapseNodeNew: (state, action) => {
      state.newExpandedNode = state.newExpandedNode.filter(
        (nodeId) => nodeId !== action.payload
      );
    },
    expandNodeLive: (state, action) => {
      if (!state.expandedNodeLive.includes(action.payload)) {
        state.expandedNodeLive.push(action.payload);
      }
    },
    collapseNodeLive: (state, action) => {
      state.expandedNodeLive = state.expandedNodeLive.filter(
        (nodeId) => nodeId !== action.payload
      );
    },
    expandNodeNewLive: (state, action) => {
      if (!state.newExpandedNodeLive.includes(action.payload)) {
        state.newExpandedNodeLive.push(action.payload);
      }
    },
    collapseNodeNewLive: (state, action) => {
      state.newExpandedNodeLive = state.newExpandedNodeLive.filter(
        (nodeId) => nodeId !== action.payload
      );
    },
    setTreeData: (state, action) => {
      state.treeDataRedux = action.payload;
    },
    setNewExpandedNode: (state, action) => {
      state.newExpandedNode = action.payload;
    },
    setDataType: (state, action) => {
      state.dataType = action.payload;
    },
  },
});

export const {
  setDataType,
  expandNodeLive,
  collapseNodeLive,
  expandNodeNewLive,
  collapseNodeNewLive,
  getDataStart,
  getDataSuccess,
  getLogSuccess,
  setTreeNode,
  expandNodeNew,
  collapseNodeNew,
  setTreeData,
  setNewExpandedNode,
  setActiveProject,
  getDataFailure,
  getDataEnd,
  getOptixDataSuccess,
  getSdkDataSuccess,
  getMobileDataSuccess,
  getResultDataSuccess,
  getQuestionListDataSuccess,
  resetSkidSlice,
  clearOptixData,
  clearOptixImageSdkMobileData,
  clearImageData,
  expandNode,
  collapseNode,
} = skidSlice.actions;

export default skidSlice.reducer;
